<template>
  <div class="aiw2-placeholder aiw2-card">
    <div class="icon">✶</div>
    <h2>Draft - coming in the next stage</h2>
    <p>
      Your title is set. Draft (Structure + Content), SEO &amp; Quality and Publish are being built
      in the following stages of the redesign. You can go back to review earlier steps.
    </p>
    <button class="aiw2-btn" @click="$emit('back')">← Back to Setup</button>
  </div>
</template>

<script>
export default { name: "AiwV2TitlePlaceholder" };
</script>

<style scoped>
.aiw2-placeholder { max-width: 620px; margin: 40px auto; padding: 40px; text-align: center; font-family: "Mulish", system-ui, sans-serif; }
.icon { font-size: 2rem; color: var(--pop-orange, #ff5700); }
.aiw2-placeholder h2 { font-size: 1.2rem; font-weight: 800; margin: 12px 0; }
.aiw2-placeholder p { color: var(--text-3, #6b7b7e); margin-bottom: 20px; }
</style>
